export const REDIRECT = 'redirect'
export const FORCE_PASSWORD_CHANGE = 'force_password_change'
export const MULTI_FACTOR_AUTH = 'mfa'
